<template>
  <div class="pd-x-10">
    <!-- <div class="media-list">
      <div v-for="(t, i) in tasks" :key="i">
          <div class="d-sm-flex pd-20">
          <a @click="$emit('on-order', t)" role="button" class="wd-100 wd-md-50 wd-lg-100 ht-60 ht-md-40 ht-lg-60 pos-relative">
            <div v-if="isNewBook(t)" class="marker marker-ribbon marker-success pos-absolute t-0 l-0">Шинэ</div> 
              <img    :src="`${t.defaultAttachmentUrl}`" class="img-fit-cover" alt="">
          </a>
          <div class="media-body mg-t-20 mg-sm-t-0 mg-sm-l-20">
              <div class="d-flex">
                  <a @click="$emit('on-order', t)" role="button" class="d-block tx-uppercase tx-11 tx-medium mg-b-5">{{t.st1}}</a>
                  <span class="mg-l-auto tx-color-03 tx-11">{{t.st2}} он</span>
              </div>
              <h6><a @click="$emit('on-order', t)" role="button" class="link-01">{{t.task}}</a></h6>
              <div class="d-flex">
                <p class="tx-color-03 tx-13 mg-b-0">ISBN: {{t.st3}}</p>
                <button @click="$emit('on-order', t)" class="mg-l-auto btn btn-xs btn-outline-light btn-uppercase">Захиалах</button>
              </div>
          </div>
          </div>
          <hr class="mg-0">
      </div>
    </div> -->
    <div class="row row-xs mg-b-25 books">
      <div
        class="col-sm-4 col-md-3 col-lg-4 col-xl-3 pd-x-15-f"
        v-for="(t, i) in tasks"
        :key="i"
      >
        <div class="card" style="box-shadow: none; border: 1px solid #e1e1e1">
          <div class="bd-b">
            <img
              :src="`${t.defaultAttachmentUrl}?w=210&h=297&mode=pad`"
              class="card-img-top pd-10"
              alt=""
              style="max-height: 250px; min-height: 250px"
            />
          </div>
          <div class="card-body tx-13 pd-y-10 pd-x-20 bg-light">
            <div>
              <h6 class="text-center ht-40 mg-b-0">{{ t.task }}</h6>
              <div class="d-flex mg-t-10 text-muted">
                <p class="text-truncate pd-r-10" :title="t.st1">{{ t.st1 }}</p>
                <p class="mg-l-auto">{{ t.st2 }}он</p>
              </div>
              <a @click="$emit('on-order', t)" class="btn btn-block btn-white"
                >Захиалах</a
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const moment = require("moment");

export default {
  props: {
    tasks: {
      type: Array,
      default: () => []
    },
    nowDate: {
      type: String,
      default: () => null
    }
  },
  methods: {
    isNewBook(t) {
      //console.log(this.tasks)
      let rv = false;
      var a = moment(t.createdDate);
      var b = moment(this.nowDate);
      if (b.diff(a, "days") <= 14) {
        rv = true;
      }
      return rv;
    }
  }
};
</script>

<style></style>
